<form #form="ngForm" (ngSubmit)="_onSubmit(form)" class="flex flex-col h-full">
	<header class="custom-requisition-form__header">
		<ng-content #header select="[header-content]"></ng-content>
		<button
			type="button"
			(click)="closeModal()"
			aria-label="Close"
			[testHook]="testHooks.CloseModalButton"
		>
			<app-icon
				[icon]="X_MARK_ICON"
				class="text-2xl"
				iconStyle="fa-solid"
			></app-icon>
		</button>
	</header>
	<section class="custom-requisition-form__body">
		<fieldset class="custom-requisition-form__body__columns">
			<h4>Primary Details</h4>
			<app-radio-group
				name="RequisitionType"
				[ngModel]="requisitionPrecedent.isOnTitle"
				class="flex-none"
				label="Requisition Type"
				[items]="requisitionTypeItems"
				type="compact"
				(ngModelChange)="onRequisitionTypeChange($event)"
				[testHook]="testHooks.RequisitionTypeRadioGroup"
			></app-radio-group>
			<app-dropdown
				class="flex-none"
				name="requisitionPrecedent"
				[ngModel]="selectedDefaultRequisitionName"
				[itemGroups]="[
					{ items: requisitions$ | async, template: requisitionItem },
				]"
				label="Select a Requisition to Duplicate"
				(onSelect)="onRequisitionSelect($event)"
				placeholder="Search Requisition Template"
				required
				[testHook]="testHooks.SelectARequisitionToDuplicateDropdown"
			></app-dropdown>
			<app-input
				name="customRequisitionName"
				class="flex-none"
				[(ngModel)]="requisitionPrecedent.name"
				label="Requisition Name"
				[disabled]="!selectedDefaultRequisitionName"
				(ngModelChange)="onRequisitionNameChange($event)"
				[required]="true"
				[placeholder]="selectedDefaultRequisitionName"
				[requisitionNameUnique]="isEdit ? selectedRequisitionId : null"
				[testHook]="testHooks.RequisitionName"
			></app-input>
		</fieldset>
		<fieldset class="custom-requisition-form__body__columns">
			<h4>Requisition Information</h4>
			<div
				*ngIf="
					(requisitionPrecedent?.fields | keyvalue)?.length;
					else noRequisitionPrecedentFields
				"
				class="custom-requisition-form__body__list"
			>
				<label
					class="flex truncate"
					*ngFor="let field of requisitionPrecedent.fields | keyvalue"
					class="custom-requisition-form__body__list-item"
				>
					{{ field.value.label }}
					<input
						type="checkbox"
						name="requisitionTagTexts-{{ field.key }}"
						[requisitionTagTextValidation]="field.value.name"
						[instrumentText]="requisitionPrecedent.text"
						[requisitionText]="requisitionPrecedent.requisitionText"
						(instrumentTextChange)="onInstrumentTextChange($event)"
						(requisitionTextChange)="onRequisitionTextChange($event)"
						[testHook]="testHooks.Input"
					/>
				</label>
			</div>
		</fieldset>
		<fieldset
			[disabled]="!selectedDefaultRequisitionName"
			required
			class="custom-requisition-form__body__columns"
		>
			<h4>Requisition Text</h4>
			<app-requisition-text-areas
				name="requisitionTexts"
				[(ngModel)]="requisitionPrecedent"
				[initialValueText]="initialRequisitionTexts"
			></app-requisition-text-areas>
		</fieldset>
	</section>
	<footer
		class="flex items-center w-full pt-6 py-2 border-t border-gray-200 justify-between [&:has(>:only-child)]:justify-end"
	>
		<ng-content #footer select="[footer-content]"></ng-content>
	</footer>
</form>

<ng-template #noRequisitionPrecedentFields>
	<p *ngIf="requisitionPrecedent?.id; else noRequisitionPrecedent">
		There are no default tags associated with this requisition.
	</p>
</ng-template>

<ng-template #noRequisitionPrecedent>
	<p>Please select a template to begin.</p>
</ng-template>

<ng-template
	#requisitionItem
	let-item
	let-index="index"
	let-intercomAttr="intercomAttr"
>
	<div
		class="flex relative"
		attr.data-intercom-target="{{ intercomAttr }}-{{ index }}"
	>
		<div class="text-sm flex justify-between items-center min-w-0 w-full">
			<span class="truncate flex-1">
				{{ item.name }}
			</span>
			<span
				*ngIf="!item.closerDefault"
				class="bg-grey-lighter text-grey-dark p-2 text-xs"
			>
				Custom
			</span>
		</div>
	</div>
</ng-template>
